// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type PromptTemplate } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetAufgabePromptTemplate(): (
  languagecode: string
) => Promise<PromptTemplate> {
  const getAPI = useGetApi();
  return useCallback(
    async (languagecode) =>
      (await getAPI()).aufgaben.getAufgabePromptTemplate({ languagecode }),
    [getAPI]
  );
}
